export default __webpack_public_path__ + "static/media/JELLOO.cb3a96c6.png";